import { ClientDocumentRelation } from '../model/client-document-relation.model';
import { TxDocument } from '../model/document.model';

export function checkCanReadRelation(document: TxDocument, clientId: string): boolean {
  return document.getSignerById(clientId)?.relation === ClientDocumentRelation.CanRead;
}

export function checkMustReadRelation(document: TxDocument, clientId: string): boolean {
  return document.getSignerById(clientId)?.relation === ClientDocumentRelation.MustRead;
}

export function checkMustSignRelation(document: TxDocument, clientId: string): boolean {
  return document.getSignerById(clientId)?.relation === ClientDocumentRelation.MustSign;
}
